import { CreateRelocationInput } from "@/gql/graphql";
import { RelocationFormValues } from "@/app/Relocations/Utils/getDefaultRelocationValues";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import {
  addDestinationMutation,
  createRelocationMutation,
} from "@/app/Relocations/GraphQL/relocationMutations";
import { toast } from "sonner";
import { useNavigate } from "@tanstack/react-router";

export function useCreateRelocationFromForm() {
  const navigate = useNavigate();
  const { mutateAsync: createRelocation } = useGqlMutation(
    createRelocationMutation,
  );
  const { mutateAsync: addDestinations } = useGqlMutation(
    addDestinationMutation,
  );

  return async function createRelocationFromForm(values: RelocationFormValues) {
    const { deliveryOfficeIds, ...rest } = values;
    const [firstOfficeId, ...additionalOfficeIds] = deliveryOfficeIds;

    const input: CreateRelocationInput = {
      ...rest,
      deliveryOffice: {
        connect: firstOfficeId,
      },
    };

    const res = await createRelocation({ input });

    if (additionalOfficeIds.length > 0) {
      await addDestinations({
        relocationId: res.createRelocation.id,
        officeIds: additionalOfficeIds,
      });

      toast.success(
        `${additionalOfficeIds.length} additional destination${additionalOfficeIds.length > 1 ? "s" : ""} added`,
        {
          action: {
            label: "View",
            onClick: () => {
              navigate({
                from: "/$tenant/$orgId/supplier/{-$supplierId}",
                to: "/$tenant/$orgId/supplier/{-$supplierId}/relocations/$relocationId/lines",
                params: (prev) => ({
                  ...prev,
                  relocationId: res.createRelocation.id,
                }),
              });
            },
          },
        },
      );
    }

    toast.success(`${res.createRelocation.reference} created`, {
      action: {
        label: "View",
        onClick: () => {
          return navigate({
            from: "/$tenant/$orgId/supplier/{-$supplierId}",
            to: "/$tenant/$orgId/supplier/{-$supplierId}/relocations/$relocationId",
            params: (prev) => ({
              ...prev,
              relocationId: res.createRelocation.id,
            }),
          });
        },
      },
    });

    return res.createRelocation;
  };
}
